export const OPEN_ALWAYS_TEXT = 'Open 24/7';
export const OPEN_NOW_TEXT = 'Open';
export const OPENING_SOON_TEXT = 'Opening Soon';
export const CLOSING_SOON_TEXT = 'Closing Soon';
export const CLOSED_NOW_TEXT = 'Closed Now';
export const PERMANENTLY_CLOSED_TEXT = 'Permanently Closed';
export const UNKNOWN_HOURS_TEXT = 'Unknown Hours';
export const INFO_FIELD_DEFAULT_STATE = '-';
